<template>
  <div class="qingsu-channel-top">
    <div :class="['qingsu-channel-top-navbar', scrollDirection]" ref="navbar">
      <div class="logo-and-name">
        <template v-if="brandData.logo && brandData.brand_name">
          <div class="logo" v-if="brandData.logo">
            <img :src="brandData.logo | imgZip(100)" />
          </div>
          {{ brandData.brand_name }}
          <div class="line" v-if="showYxlLogo" />
          <!-- <div class="line-x">|</div> -->
        </template>
        <template v-if="showYxlLogo">
          <div class="logo">
            <img :src="yixinliLogo.img | imgZip(100)" />
          </div>
          {{ yixinliLogo.title }}
        </template>
      </div>
      <div class="icons-entry" v-if="isShowEntry">
        <div class="icon-item" @click="linkToUserCenter" v-stat="'点击我的'">
          <VantBadge
            :content="
              userNotice && +userNotice.user_notice.message_num
                ? userNotice.user_notice.message_num
                : ''
            "
            max="99"
          >
            <img src="~images/qingsu/home/qingsu-header-icon-my.png" />
          </VantBadge>
        </div>
        <div class="icon-item" @click="linkToOrderList('')" v-stat="'点击订单'">
          <VantBadge :content="+progressNum ? progressNum : ''" max="99">
            <img src="~images/qingsu/home/qingsu-header-icon-order.png" />
          </VantBadge>
        </div>
      </div>
    </div>
    <div
      :class="{
        'qingsu-channel-top-img': true,
        'auto-height': bannerAutoHeight
      }"
      v-if="brandData.head_image"
    >
      <img :src="brandData.head_image | imgZip(750)" @click="toHeadImageUrl" />
      <div class="btn" @click="$emit('showRule')" v-if="showRuleBtn">
        服务介绍
      </div>
    </div>
    <div class="qingsu-channel-top-links-container" v-if="parseList.length">
      <div v-swiper:mySwiper="swiperConfig" class="qingsu-channel-top-links">
        <div class="swiper-wrapper">
          <div
            :class="{
              'swiper-slide': true,
              'qingsu-channel-top-links-list': true,
              center: block.length < 5
            }"
            v-for="(item, index) in parseList"
            :key="index"
          >
            <div
              class="qingsu-channel-top-links-item"
              v-for="(v, i) in item"
              :key="i"
              @click="$emit('linkClick', v)"
            >
              <img :src="v.img || v.image" class="img" />
              <div class="title">{{ v.title }}</div>
            </div>
          </div>
        </div>
        <div
          class="qingsu-channel-top-pagination"
          v-if="parseList.length > 1"
        />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import { Badge as VantBadge } from 'vant'
import { mapState } from 'vuex'
import qs from 'qs'

export default {
  props: {
    scrollDirection: {
      type: String
    },
    brandData: {
      type: Object
    },
    block: {
      type: Array
    },
    showYxlLogo: {
      type: Boolean,
      default: true
    },
    showRuleBtn: {
      type: Boolean,
      default: true
    },
    bannerAutoHeight: {
      type: Boolean,
      default: false
    },
    progressNum: {
      type: Number,
      default: 0
    },
    isShowEntry: {
      // 倾诉外部渠道隐藏入口
      type: Boolean,
      default: true
    }
  },
  components: {
    VantBadge
  },
  mounted() {
    this.$emit('getNavbarHeight', this.$refs['navbar'].clientHeight)
  },
  computed: {
    ...mapState(['userNotice']),
    yixinliLogo() {
      return {
        img: `https://ossimg.xinli001.com/20190724/cd2c3853c483ae18128e2358dbf423f2.jpeg`,
        title: '壹心理'
      }
    },
    // block() {
    //   return this.$store.state.qingsuindex.freeQingsuBlock
    // },
    swiperConfig() {
      return {
        pagination: {
          el: '.qingsu-channel-top-pagination'
        }
      }
    },
    parseList() {
      // const data = new Array(20).fill('').map(() => ({
      //   id: '8955',
      //   img:
      //     'https://ossimg.xinli001.com/20200125/398a515da4cdf780f8bd3d3f1055edd7.jpg',
      //   url: 'https://3g.dxy.cn/newh5/view/pneumonia',
      //   title: '广告图1111',
      //   subtitle: 'zh',
      //   object_name: 'static',
      //   adsite_id: '144',
      //   name: 'qingsu-channel-banner',
      //   is_show: '1'
      // }))
      const data = this.block
      var result = []
      for (var i = 0; i < data.length; i += 10) {
        result.push(data.slice(i, i + 10))
      }
      if (this.$isServer) return result
      if (window.__wxjs_environment === 'miniprogram') return []
      // return [...result, ...result]
      return result
    }
  },
  methods: {
    linkToOrderList(source) {
      this.trackH5Event('订单')
      this.$emit('linkToOrderListStat')
      const cid = this.$route.query.cid || ''
      this.routerToStaic({
        path: '/qingsu-order-list',
        query: {
          filter: source ? 'waitRate' : 'all',
          from: source,
          cid
        }
      })
    },
    linkToUserCenter() {
      this.trackH5Event('我的')
      const { query } = this.$route
      this.routerPushWithoutNav(
        'https://m.xinli001.com/consult/userCenter?' + qs.stringify(query)
      )
    },
    toHeadImageUrl() {
      const { head_image_url } = this.brandData
      if (!head_image_url) return
      this.toAdPage({
        url: head_image_url
      })
    },
    trackH5Event(name) {
      const { cid = '', channel_flag = '' } = this.$route.query
      this.$trackEvent('listen_channel_buttonclick', {
        channel_id: cid || '',
        button_name: name ? name : '',
        channel_flag,
        cid
      })
    }
  }
}
</script>

<style lang="scss">
.qingsu-channel-top {
  padding-top: 93px;
  &-navbar {
    position: fixed;
    left: 50%;
    top: 0;
    width: 750px;
    margin-left: -375px;
    height: 93px;
    display: flex;
    z-index: 2;
    background: #f8f8f8;
    justify-content: space-between;
    transition: transform 0.5s;
    color: #333333;
    &.up {
      transform: translate3d(0, -100%, 0);
    }
    .logo-and-name {
      display: flex;
      align-items: center;
      padding-left: 30px;
      line-height: 1.25;
      font-size: 28px;
      .logo {
        border-radius: 50%;
        overflow: hidden;
        margin-right: 10px;
        border: 1px solid #f0f0f0;
        &,
        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          object-position: center;
        }
      }
      .line {
        width: 2px;
        background: #999;
        margin: 0 20px;
        height: 35px;
      }
      // .line-x {
      //   margin: 0 20px;
      //   font-size: 24px;
      //   line-height: 1.25;
      //   color: #999;
      // }
    }
    .icons-entry {
      padding: 0 30px;
      display: flex;
      align-items: center;
    }
  }
  &-img {
    height: 300px;
    overflow: hidden;
    position: relative;

    &.auto-height {
      height: auto;
    }
    .btn {
      position: absolute;
      right: 0;
      top: 30px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 8px 0px 0px 8px;
      padding: 0 10px;
      height: 44px;
      font-size: 24px;
      color: #ffffff;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &-links-container {
    padding: 0 30px 30px;
    margin-top: -57px;
    box-sizing: border-box;
  }
  .qingsu-channel-top-pagination {
    height: 12px;
    display: flex;
    padding-bottom: 20px;
    justify-content: center;
    .swiper-pagination-bullet {
      width: 12px !important;
      height: 12px !important;
      border-radius: 50% !important;
      background: #7f94fb !important;
      margin: 0 10px !important;
      opacity: 1 !important;
      box-sizing: border-box !important;
      &-active {
        background: #fff !important;
        border: 1px solid #7f94fb !important;
      }
    }
  }
  &-links {
    font-size: 0;
    line-height: 0;
    overflow: hidden;
    position: relative;
    background: #ffffff;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 30px;
    &-list {
      padding: 15px 0;
      box-sizing: border-box;
      &.center {
        display: flex;
        .qingsu-channel-top-links-item {
          flex: 1;
        }
      }
    }
    &-item {
      width: 20%;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 15px 0;
      .img {
        width: 50px;
        height: 50px;
        object-fit: cover;
      }
      .title {
        font-size: 22px;
        color: #333333;
        text-align: center;
        line-height: 26px;
        padding-top: 20px;
      }
    }
  }

  .qingsu-channel-share-btn {
    position: fixed;
    right: 0;
    bottom: 300px;
    background: #ff745b;
    box-shadow: 0 2px 4px 0 rgba(138, 138, 138, 0.5);
    border-radius: 62px 0px 0px 62px;
    width: 130px;
    height: 80px;
    border-radius: 50px 0 0 50px;
    font-size: 24px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 28px;
    text-align: center;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 8px;
    box-sizing: border-box;
    transition: transform 0.5s;
    z-index: 2;
    &.up {
      transform: translate3d(100%, 0, 0);
    }
  }

  .qingsu-channel-share-img-model {
    z-index: $modelZIndex;
    display: flex;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    $w: 550px;
    .img {
      width: $w;
      // height: 750 * 1334 / $w;
    }
    .msg {
      font-size: 30px;
      line-height: 1.5;
      padding-top: 20px;
    }
    .icon {
      width: $w;
      height: 76px;
    }
    .icon-node-website {
      font-size: 56px;
      float: right;
      margin-right: -40px;
    }
  }

  .icons-entry {
    .van-badge__wrapper {
      position: relative;
      width: 40px;
      height: 90px;
      .van-badge--fixed {
        top: 20px;
      }
    }
    .icon-item {
      width: 40px;
      height: 90px;
      position: relative;
      margin-left: 60px;
      img {
        width: 40px;
        height: 80px;
        position: absolute;
        top: 10px;
        left: 0;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
